import React from 'react'
import { AnimatedLoaderGradient } from '@components/AnimatedLoaderGradient/AnimatedLoaderGradient'
import { useVisualViewportContext } from '@components/VisualViewportContext/VisualViewportContext'
import { Box, Paragraph, Stack } from '@ui'
import { AnimatePresence } from 'framer-motion'

type Props = {
    children?: React.ReactNode
    contentLeft?: React.ReactNode
    contentRight?: React.ReactNode
    extraHeight?: boolean
    showLoadingIndicator?: boolean
    noBackground?: boolean
}

export const TouchNavBar = (props: Props) => {
    const { noBackground } = props
    const centerContent = typeof props.children === 'string'
    const hasSideContent = !!props.contentLeft || !!props.contentRight
    const { offset } = useVisualViewportContext()
    return (
        <>
            {/* placeholder space */}
            <Stack>
                <Stack minHeight={props.extraHeight ? 'x7' : 'x6'} />
            </Stack>
            {/* absolute position to adapt to virtual keyboard */}
            <Box
                elevateReadability={!noBackground}
                zIndex="uiAbove"
                width="100%"
                style={{
                    position: 'absolute',
                    top: `calc(${offset ?? 0}px - var(--tabbar-vertical-offset, 0))`,
                }}
            >
                <Stack
                    borderBottom={!noBackground ? 'default' : undefined}
                    height={props.extraHeight ? 'x7' : 'x6'}
                    justifyContent="end"
                >
                    <Stack horizontal justifyContent="center" height="100%" paddingY="sm">
                        {hasSideContent && (
                            <Box centerContent minWidth="x8">
                                {props.contentLeft}
                            </Box>
                        )}
                        <Stack
                            grow
                            position="relative"
                            overflow="hidden"
                            justifyContent="center"
                            alignItems={centerContent ? 'center' : undefined}
                        >
                            {centerContent ? (
                                <Paragraph truncate strong color="default" size="lg">
                                    {props.children}
                                </Paragraph>
                            ) : (
                                props.children
                            )}
                        </Stack>
                        {hasSideContent && (
                            <Box
                                horizontal
                                minWidth="x8"
                                justifyContent="end"
                                alignItems="center"
                                paddingRight="md"
                            >
                                {props.contentRight}
                            </Box>
                        )}
                    </Stack>
                    <AnimatePresence>
                        {props.showLoadingIndicator && <AnimatedLoaderGradient />}
                    </AnimatePresence>
                </Stack>
            </Box>
        </>
    )
}
